"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailTransactionSm = void 0;
var React = require("react");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var format_1 = require("@/utils/format");
var react_redux_1 = require("react-redux");
var mapDetailStateToProps = function (state) {
    return ({
        t: state.otherTransactions.t,
        transactions: state.otherTransactions.transactions,
        resultT: state.resultT,
        symbolHkd: state.layout.currencies.options.find(function (it) { return it.key === SfilterPriceGroup_1.SfilterCurrency.HKD; }).symbol,
        lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1,
    });
};
var mapDispatchToProps = function (dispatch) { return ({}); };
var detailTransactionsSm = function (props) {
    if (!props.transactions || !props.transactions.length)
        return React.createElement(React.Fragment, null);
    var renderTransactionRow = function (it) {
        var dateStr = format_1.default.dateFormat(new Date(it.date));
        var priceStr = format_1.default.currencySale(it.price, props.lang);
        var ppsfStr = it.size ? "" + format_1.default.currencyLease(it.price / it.size, props.lang) + (it.sizeUnit === 'g' ? " " + props.t.grossAbbr2 : '') : '';
        var sizeStr = it.size ? "" + format_1.default.comma(it.size) + (it.sizeUnit === 'g' ? " " + props.t.grossAbbr2 : '') : '';
        return (React.createElement("div", { className: "c-proptransaction__row" },
            React.createElement("div", { className: "c-proptransaction__col" }, dateStr),
            React.createElement("div", { className: "c-proptransaction__col" }, priceStr),
            React.createElement("div", { className: "c-proptransaction__col" }, ppsfStr),
            React.createElement("div", { className: "c-proptransaction__col" }, sizeStr)));
    };
    return (React.createElement("div", { className: "c-propfeature__row l-prop__othertransactionssm" },
        React.createElement("div", { className: "c-proptransaction" },
            React.createElement("div", { className: "c-proptransaction__heading" }, props.t.otherTransactions),
            React.createElement("div", { className: "c-proptransaction__header" },
                React.createElement("div", { className: "c-proptransaction__row" },
                    React.createElement("div", { className: "c-proptransaction__col" }, props.t.transactionDate),
                    React.createElement("div", { className: "c-proptransaction__col" }, props.t.transactionPrice),
                    React.createElement("div", { className: "c-proptransaction__col" }, props.t.transactionPpsf),
                    React.createElement("div", { className: "c-proptransaction__col" }, props.t.transactionSize))),
            React.createElement("div", { className: "c-proptransaction__body" }, props.transactions.map(renderTransactionRow)))));
};
exports.DetailTransactionSm = react_redux_1.connect(mapDetailStateToProps, mapDispatchToProps)(detailTransactionsSm);
